module.exports = __webpack_public_path__ + "0627dda4d1a66d0cf7369388d31fcf20.svg";